import React, { useState } from "react";
import TagCrossGray from "../images/tag-cross-gray.png";
import { Input, Row, Col } from "reactstrap";
import { newDateChanger } from "../Utils/CommonFunction";
import ShareuserIcons from "./ShareuserIcons";
import moment from "moment";
function GridView(props) {
  return (
    <Row xs="6" className="grid-row">
      {props.data?.map((item, index) => {
        return (
          <GridItem
            onButton={(item) => props?.onItem(item)}
            env_subfolder={props?.env_subfolder}
            item={item}
          />
        );
      })}
    </Row>
  );
}
const GridItem = (props) => {
  const [mouseHandel, setMouseHandel] = useState(false);
  return (
    <Col
      className="grid-item"
      style={{
        boxShadow: mouseHandel
          ? "5px 5px 21px 0px rgba(197, 197, 197, 0.79)"
          : "",
      }}
      onMouseOver={(e) => setMouseHandel(true)}
      onMouseLeave={(e) => setMouseHandel(false)}
    >
      <div className="grid-item-title ">
        <div className="grid-item-foldername">
          <img
            src={TagCrossGray}
            alt="folder"
            style={{ width: "16px", height: "16px" }}
          />
          <h6>{props?.item?.name}</h6>
        </div>
        {/* <Input
          type="checkbox"
          style={{
            width: "18px",
            height: "18px",
            border: "1px solid #131313",
            cursor: "pointer",
          }}
        /> */}
      </div>
      <div className="grid-item-body">
        {props.env_subfolder ? null : (
          <div className="grid-item-body-item">
            <p>Total Environment</p>
            <h6>{props?.item?.totalEnvs}</h6>
          </div>
        )}
        <div className="grid-item-body-item">
          <p>Total Password</p>
          <h6>{props?.item?.totalPasswords}</h6>
        </div>
        <div className="grid-item-body-item">
          <p>Created On</p>
          <h6>{moment(props?.item?.createdAt).format("ll")}</h6>
        </div>
        <div className="grid-item-body-item">
          <p>Created By</p>
          <h6>{props?.item?.userName}</h6>
        </div>
        <div className="grid-item-body-item">
          <p>Shared With</p>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <ShareuserIcons
              folderId={
                props?.env_subfolder
                  ? props?.item?.folderId
                  : props?.item?.passwordFolderId
                  ? props?.item?.passwordFolderId
                  : props?.item?._id
              }
              envId={
                props?.item?.envId
                  ? props?.item?.envId
                  : props?.props?.env_subfolder
                  ? props?.item?._id
                  : ""
              }
              env_subfolder={props?.env_subfolder}
            />
          </div>
        </div>
      </div>
      <GridButton
        onButton={() => props.onButton(props?.item)}
        env_subfolder={props?.env_subfolder}
      />
    </Col>
  );
};
const GridButton = (props) => {
  const [mouseButton, setMouseButton] = useState(false);
  return (
    <div
      className="grid-box-footer"
      onClick={() => {
        // if (!props?.env_subfolder) {
        props?.onButton();
        // }
      }}
    >
      <div
        className="grid-item-button"
        style={{ background: mouseButton ? "  #184CA1" : "" }}
        onMouseOver={(e) => setMouseButton(true)}
        onMouseLeave={(e) => setMouseButton(false)}
      >
        <h5 style={{ color: mouseButton ? "  #FFF" : "" }}>
          View Details
        </h5>
      </div>
    </div>
  );
};
export default GridView;
